import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Avatar, Box, Button, useMediaQuery } from "@mui/material";
import GenieText from "../../core/genie-text/GenieText";
import { theme } from "../genie-theme/genie-theme";
import { useNavigate } from "react-router-dom";

interface GenieProfileProps {
  isOnlyLogo?: boolean;
}

const GenieProfile = (props: GenieProfileProps) => {
  const { loginWithRedirect, user, isAuthenticated, isLoading } =
    useAuth0();
  const { isOnlyLogo } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const avatarSize = isMobile ? 24 : 48;
  if (!isAuthenticated && !isLoading) {
    return (
      <Button
        variant={"contained"}
        fullWidth
        onClick={() => loginWithRedirect()}
      >
        Log In
      </Button>
    );
  } else if (isAuthenticated && !isLoading && user) {
    return (
      <Box display={isOnlyLogo ? "flex" : "block"} alignItems={"center"}>
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"flex-start"}
        >
          <Avatar
            src={user.picture}
            alt={user.name}
            sx={{
              width: avatarSize,
              height: avatarSize,
              fontSize: isMobile ? 12 : "initial",
            }}
          />
          {!isOnlyLogo && (
            <Box
              ml={1}
              textOverflow={"ellipsis"}
              overflow={"hidden"}
              whiteSpace={"nowrap"}
            >
              <GenieText fontSize={"tiny"}>{user.name}</GenieText>
            </Box>
          )}
        </Box>
        {!isOnlyLogo && (
          <Box mt={2}>
            <Button
              variant={"outlined"}
              fullWidth
              color={"secondary"}
              onClick={() => {
                navigate("/logout");
              }}
            >
              Log Out
            </Button>
          </Box>
        )}
      </Box>
    );
  }
  return null;
};

export default GenieProfile;
